import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgModule } from '@angular/core';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { BaseIdDirective, ChildIdDirective, CoreUiModule } from 'webcommon/core-ui';

import {
  ApColumnActionIconsComponent,
  ApColumnCheckboxComponent,
  ApColumnDateComponent,
  ApColumnDropdownComponent,
  ApColumnFindcontrolComponent,
  ApColumnHtmlComponent,
  ApColumnHyperlinkComponent,
  ApColumnNumberComponent,
  ApColumnRadioButtonComponent,
  ApColumnStringComponent,
  ApColumnTimeFrameComponent,
  ApConfigurableTableComponent,
  ApHyperlinkColumnSelectorComponent,
} from './ap-configurable-table/index';
import {
  ApDxProblemsModalComponent,
  FcDxProblemsComponent,
} from './ap-dx-problems/index';
import {
  ApColumnExtFindControlComponent,
  ApColumnExtTimeFrameComponent,
  ApFindControlAdvancedComponent,
  ApFindControlComponent,
  ApFindControlGenericComponent,
  ApFindControlModalComponent,
  ApFindControlModifyInformationTabComponent,
  ApFindControlModifyModalComponent,
  ApFindControlModifySecurityTabComponent,
  ApFindControlReorderColumnsModalComponent,
  DxFindcontrol2Component,
  FcAddressListComponent,
  FcAnsiListFilterModalComponent,
  FcAnsiListModalComponent,
  FcClaimsListComponent,
  FcCopyContactInfoListModalComponent,
  FcCorporationListComponent,
  FcCorporationListModalComponent,
  FcDemographicsTabComponent,
  FcEmployerListModalComponent,
  FcEmploymentListModalComponent,
  FcFacilityPortalAccessListComponent,
  FcFacilityPortalPersonListModalComponent,
  FcGeneralFilterModalComponent,
  FcGeneralModalComponent,
  FcGenericListFilterModalComponent,
  FcGenericListModalComponent,
  FcIndustryListModalComponent,
  FcInsuranceContactListModalComponent,
  FcInsurancePayerListModalComponent,
  FcInsurancePlanCHCTabComponent,
  FcInsurancePlanClinicalTabComponent,
  FcInsurancePlanContactInfoTabComponent,
  FcInsurancePlanListModalComponent,
  FcInsurancePlanSettingTabComponent,
  FcJobScheduleListModalComponent,
  FcLaboratoryBillCodeListModalComponent,
  FcLabsProvidersListComponent,
  FcLanguageListModalComponent,
  FcListValidationPipe,
  FcMacroGroupListModalComponent,
  FcMedicalServiceProviderListModalComponent,
  FcMergeItemModalComponent,
  FcNameDetailsComponent,
  FcNewInsurancePeriodListModalComponent,
  FcNewItemButtonComponent,
  FcNewItemFindcontrolButtonComponent,
  FcOccupationListModalComponent,
  FcOtherInformationComponent,
  FcPatientConditionListModalComponent,
  FcPatientProgramGeneralTabComponent,
  FcPatientProgramListModalComponent,
  FcPayerIdOverrideListComponent,
  FcPersonListComponent,
  FcPersonWebAccountListModalComponent,
  FcPharmacyClearinghouseInterfaceDetailsTabComponent,
  FcPharmacyClearinghouseModalComponent,
  FcPharmacyClearinghouseProviderTabComponent,
  FcPharmacyListModalComponent,
  FcPharmacyManagePharmacyTabComponent,
  FcPhoneNumberListComponent,
  FcPhoneTypeListModalComponent,
  FcProcedureMappingListComponent,
  FcResponsiblePartyListModalComponent,
  FcScheduledReportListModalComponent,
  FcSettingsListComponent,
  FcTextColorListComponent,
  FcVisitCheckListModalComponent,
  FcWorkersCompComponent,
  FcZipListModalComponent,
  MapInsuranceNetworkComponent,
  MapInsuranceNetworkModalComponent,
  YesNoPipe,
} from './ap-findcontrol/index';
import { ApTimeSpanSelectorModalComponent, ApTimespanFindControlComponent } from './ap-timespan/index';
import { ApColorSelectorComponent } from './shared/index';
import { ApTypeaheadFindControlFieldDirective } from './typeahead-findcontrol/index';

const filterModalExports = [
  FcAnsiListFilterModalComponent,
  FcGenericListFilterModalComponent,
];

const listModalExports = [
  FcOccupationListModalComponent,
  FcIndustryListModalComponent,
  FcGeneralModalComponent,
  FcAnsiListModalComponent,
  FcNewInsurancePeriodListModalComponent,
  FcCopyContactInfoListModalComponent,
  FcPhoneTypeListModalComponent,
  FcCorporationListModalComponent,
  FcEmployerListModalComponent,
  FcInsuranceContactListModalComponent,
  FcZipListModalComponent,
  FcLanguageListModalComponent,
  FcPatientConditionListModalComponent,
  FcPatientProgramListModalComponent,
  FcInsurancePayerListModalComponent,
  FcPharmacyListModalComponent,
  FcInsurancePlanListModalComponent,
  FcMedicalServiceProviderListModalComponent,
  FcPersonWebAccountListModalComponent,
  FcMedicalServiceProviderListModalComponent,
  FcLaboratoryBillCodeListModalComponent,
  FcFacilityPortalPersonListModalComponent,
  FcResponsiblePartyListModalComponent,
  FcEmploymentListModalComponent,
];

const configurableTableExports = [
  ApColumnActionIconsComponent,
  ApColumnCheckboxComponent,
  ApColumnDateComponent,
  ApColumnDropdownComponent,
  ApColumnFindcontrolComponent,
  ApColumnHtmlComponent,
  ApColumnHyperlinkComponent,
  ApColumnNumberComponent,
  ApColumnRadioButtonComponent,
  ApColumnStringComponent,
  ApColumnTimeFrameComponent,
  ApConfigurableTableComponent,
  ApHyperlinkColumnSelectorComponent,
  ApColumnExtTimeFrameComponent,
  ApColumnExtFindControlComponent,
];

const exportComponents = [
  ApColorSelectorComponent,
  ApDxProblemsModalComponent,
  ApFindControlAdvancedComponent,
  ApFindControlComponent,
  ApFindControlGenericComponent,
  ApFindControlModalComponent,
  ApFindControlModifyInformationTabComponent,
  ApFindControlModifyModalComponent,
  ApFindControlModifySecurityTabComponent,
  ApFindControlReorderColumnsModalComponent,
  ApTimespanFindControlComponent,
  ApTimeSpanSelectorModalComponent,
  ApTypeaheadFindControlFieldDirective,
  DxFindcontrol2Component,
  FcAddressListComponent,
  FcClaimsListComponent,
  FcCorporationListComponent,
  FcDemographicsTabComponent,
  FcDxProblemsComponent,
  FcFacilityPortalAccessListComponent,
  FcGeneralFilterModalComponent,
  FcGenericListModalComponent,
  FcInsurancePlanCHCTabComponent,
  FcInsurancePlanClinicalTabComponent,
  FcInsurancePlanContactInfoTabComponent,
  FcInsurancePlanSettingTabComponent,
  FcLabsProvidersListComponent,
  FcListValidationPipe,
  FcMacroGroupListModalComponent,
  FcMergeItemModalComponent,
  FcNameDetailsComponent,
  FcNewItemButtonComponent,
  FcNewItemFindcontrolButtonComponent,
  FcOtherInformationComponent,
  FcPatientProgramGeneralTabComponent,
  FcPayerIdOverrideListComponent,
  FcPersonListComponent,
  FcPharmacyClearinghouseInterfaceDetailsTabComponent,
  FcPharmacyClearinghouseModalComponent,
  FcPharmacyClearinghouseProviderTabComponent,
  FcPharmacyListModalComponent,
  FcPharmacyManagePharmacyTabComponent,
  FcPhoneNumberListComponent,
  FcProcedureMappingListComponent,
  FcSettingsListComponent,
  FcTextColorListComponent,
  FcWorkersCompComponent,
  FcJobScheduleListModalComponent,
  FcScheduledReportListModalComponent,
  MapInsuranceNetworkComponent,
  MapInsuranceNetworkModalComponent,
  YesNoPipe,
  ...filterModalExports,
  ...listModalExports,
  ...configurableTableExports,
  FcVisitCheckListModalComponent,
];

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
    ...exportComponents,
  ],
  exports: [...exportComponents],
  imports: [
    CoreUiModule,
    DragDropModule,
    NgxMaskModule.forRoot(maskConfig),
    BaseIdDirective,
    ChildIdDirective,
  ],
})
export class FindControlModule { }
